import ReactDOM from "react-dom";
import { result } from "lodash";
import React, {useEffect, useRef, useState, useCallback , useContext } from "react";
import {useInfiniteQuery , QueryClient , QueryClientProvider , useQuery} from "react-query";
import { get, post } from "../http/http";
import BrandItem from "./BrandItem";
import SpinnerLoading from "../Spinner/SpinnerLoading";
import ScrollManager from '../ScrollManager/ScrollManager'
import ErrorLoadData from "../Error/ErrorLoadData";
import Header from "../Header/Header";
import { Context } from '../Context/Context';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      keepPreviousData: true,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  },
});


export default function Brands() {

  return (
    <QueryClientProvider client={queryClient}>
      <ScrollManager scrollKey="brandIndex" />

      <div className="list_parent">
      <Header title={"لیست برندها"} urlCreateBtn={"/brand/create"}  txtCreateBtn={"افزودن برند"}/>
      <div className="list">
      <Records/>
      </div>
      </div>
    </QueryClientProvider>
  );
}

///////////////

const Records = ({}) => {

  const {lastIdBrand , setLastIdBrand} = useContext(Context)

  function handleRefresh(){
    queryClient.resetQueries("brands_repoData")
  }
  const request = {last_id: lastIdBrand.current };
  const {
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    data,
    status,
    error,
    isError,
    refetch,
  } = useInfiniteQuery(
    ["brands_repoData"],
    ({ pageParam = 1, signal }) =>
      post(`/api/admin/brand/index?page=${pageParam}`, request, {
        signal: signal,
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage && lastPage.length > 0) {
          lastIdBrand.current = lastPage[lastPage.length - 1].id;
        }
        return lastPage.length ? allPages.length + 1 : undefined;
      },
    }
  );

  const intObserver = useRef();
  const lastPostRef = useCallback(
    (post) => {
      if (isFetchingNextPage) return;

      if (intObserver.current) intObserver.current.disconnect();

      intObserver.current = new IntersectionObserver((posts) => {
        if (posts[0].isIntersecting && hasNextPage) {
          console.log("We are near the last post!");
          fetchNextPage();
        }
      });

      if (post) intObserver.current.observe(post);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  const content = data?.pages.map((pg) => {
    return pg.map((item, index) => {
      if (pg.length === index + 1) {
        return (
          <BrandItem
            ref={lastPostRef}
            key={item.id}
            queryClient={queryClient}
            index={index}
            item={item}
          />
        );
      }
      return (
        <BrandItem
          key={item.id}
          index={index}
          queryClient={queryClient}
          item={item}
        />
      );
    });
    
  });

  return (
    
    <div>
      
      {content}
      
      {isLoading &&
       <SpinnerLoading />
       }
      
      {isFetchingNextPage && (data.pages[data.pages.length-1]).length >= 20 &&
       <SpinnerLoading />
      }

      {isFetching && !isFetchingNextPage &&
       <SpinnerLoading/>
      } 
      
      {isLoading == false && data && Object.keys(data.pages[0]).length < 1 &&
      <div className='empty_container'>
      <div className='inner'>
      <p className='empty'>متأسفانه موردی  پیدا نشد !</p>
      </div>
      </div>  
      }
      
      {isError &&
      <ErrorLoadData func={handleRefresh}/> 
      }


    </div>
  );
};

export function useQueryClientBrands(){
  return[queryClient]
}
